import { render, staticRenderFns } from "./BadgeTemp.vue?vue&type=template&id=8e240d56&scoped=true&"
import script from "./BadgeTemp.vue?vue&type=script&lang=js&"
export * from "./BadgeTemp.vue?vue&type=script&lang=js&"
import style0 from "./BadgeTemp.vue?vue&type=style&index=0&id=8e240d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e240d56",
  null
  
)

component.options.__file = "BadgeTemp.vue"
export default component.exports